<template>
  <div class="p-grid">
    <div class="p-col-12">
      <UserTabs></UserTabs>
    </div>
    <div class="p-col-12">
      <div v-if="loadingList">
        <AppSkeletonTable></AppSkeletonTable>
      </div>
      <DataTable
        v-if="!loadingList"
        :value="resultItems"
        responsiveLayout="stack"
      >
        <Column
          header="Nome"
          field="name"
          :sortable="true"
          alignFrozen="left"
          :frozen="true"
        ></Column>
        <Column header="Descrição" field="description" :sortable="true">
          <template #body="{ data }">
            {{ data.description || '-' }}
          </template>
        </Column>
        <Column header="Permissão de Leitura">
          <template #body="{ data }">
            {{ getPermissionNames('read', data.permissions) }}
          </template>
        </Column>
        <Column header="Permissão de Escrita">
          <template #body="{ data }">
            {{ getPermissionNames('write', data.permissions) }}
          </template>
        </Column>
        <Column header="Permissão de Deleção">
          <template #body="{ data }">
            {{ getPermissionNames('delete', data.permissions) }}
          </template>
        </Column>
        <Column
          header="Ações"
          style="min-width: 100px"
          alignFrozen="right"
          :frozen="true"
        >
          <template #body="{ data }">
            <div>
              <Button
                type="button"
                icon="pi pi-pencil"
                class="p-button-text p-button-secondary p-mr-1"
                :disabled="!data.accountId || !$ability.can('write', 'User')"
                @click="showEdit(data)"
              ></Button>
              <Button
                type="button"
                icon="pi pi-trash"
                class="p-button-text p-button-secondary"
                :disabled="!data.accountId"
                @click="showDeleteConfirm(results, data.id, 'name')"
              ></Button>
            </div>
          </template>
        </Column>
      </DataTable>
      <Paginator
        v-if="!loadingList"
        :rows="query.pageSize"
        :totalRecords="pagination.total"
        @page="changeListPage({ page: $event.page + 1 })"
      ></Paginator>
      <AppFloatButton
        icon="pi pi-plus"
        @click="showEdit()"
        v-if="$ability.can('write', 'User')"
      />
      <UserTypeEdit
        ref="edit"
        v-model:visible="editVisible"
        @saved="fetchList()"
      ></UserTypeEdit>
      <AppModalDelete
        type="Tipo de Usuário"
        :visible="deleteConfirm.visible"
        :item="deleteConfirm.item"
        @confirm="onDelete()"
        @cancel="hideDeleteConfirm()"
      ></AppModalDelete>
    </div>
  </div>
</template>

<script>
import useDeleteConfirm from '../../lib/useDeleteConfirm';
import useApiList from '../../lib/useApiList';
import { UserTypeApi } from '../../services/api';
import UserTabs from './components/UserTabs.vue';
import UserTypeEdit from './UserTypeEdit.vue';
import { APP_SUBJECTS } from '../../lib/permissions';

export default {
  name: 'UserList',
  components: {
    UserTabs,
    UserTypeEdit,
  },
  setup() {
    return {
      ...useApiList(UserTypeApi),
      ...useDeleteConfirm(),
    };
  },
  data() {
    return {
      editVisible: false,
    };
  },
  async created() {
    await this.fetchList();
    this.$emitter.on('topbar-search', ({ query }) => {
      this.searchList(query);
    });
  },
  computed: {
    resultItems() {
      return this.results.map((result) => {
        return {
          ...result,
        };
      });
    },
  },
  methods: {
    onDelete() {
      this.deleteListItem(this.deleteConfirm.id);
      this.hideDeleteConfirm();
    },
    showEdit(data) {
      this.editVisible = true;
      this.$refs.edit.setData(data);
    },
    getPermissionNames(action, permissions) {
      const appSubjects = APP_SUBJECTS.filter((sub) => {
        if (action !== 'read' && sub.subject === 'Home') return false;
        return true;
      });
      const names = appSubjects
        .filter((subject) =>
          permissions.some(
            (permission) =>
              permission.subject === subject.subject &&
              permission.action === action
          )
        )
        .map((subject) => subject.name);
      if (names.length === appSubjects.length) {
        return 'Todos';
      }
      return names.join(', ') || '-';
    },
  },
};
</script>

<style scoped>
</style>
